import { render, staticRenderFns } from "./Dictionaries.vue?vue&type=template&id=21b612b0&scoped=true"
import script from "./Dictionaries.vue?vue&type=script&lang=js"
export * from "./Dictionaries.vue?vue&type=script&lang=js"
import style0 from "./Dictionaries.vue?vue&type=style&index=0&id=21b612b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b612b0",
  null
  
)

export default component.exports